import React from "react";
import { Container, Row, Table, Button, Col } from "react-bootstrap";
import { DraggableTable } from "presentation/components/draggable-table/table";
import { TableStyles } from "presentation/components/draggable-table/table-styles";

import PageLoadingIndicator from "presentation/components/page-loading-indicator";
import PageAlert from "presentation/components/page-alert";
import PageModal from "presentation/components/page-modal";

import AddButton from "presentation/components/buttons/add";

import ManageStatusIndicationModal from "presentation/pages/evaluation-schemes/elements/manage-status-indication-modal";

import DropdownMenu from "presentation/components/dropdown-menu/menu";
import EditItemTitle from "presentation/components/dropdown-menu/item-title/edit";
import RemoveItemTitle from "presentation/components/dropdown-menu/item-title/remove";
import { DROPDOWN_MENU_TYPE_ITEM } from 'presentation/model/constants';

import {
    arrayMove
} from "@dnd-kit/sortable";
import { isNullOrEmpty } from "presentation/utils/functions/generic";

class StatusIndicationTabEvaluationSchemeForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            actionLoading: false,
            error: false,
            message: '',
            data: [],
            showConfirmModal: false,
            showManageStatusIndicationModal: false,
            targetDeleteId: null,
            draggableTableData: [],
            statusIndicationKey: null,
            statusIndication: {},
            statusIndicationId: null
        };
        this.closeModal = this.closeModal.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
        this.makeData = this.makeData.bind(this);
    }

    componentDidMount() {
        this.makeData();
    }

    openModal = (id) => {
        this.setState({ targetDeleteId: id, showConfirmModal: true });
    }

    closeModal = () => {
        this.setState({ showConfirmModal: false, targetDeleteId: null });
    }

    openManageStatusIndicationModal = (statusIndication = {}, statusIndicationId = null, statusIndicationKey = null) => {
        this.setState({ showManageStatusIndicationModal: true, statusIndication: statusIndication, statusIndicationId: statusIndicationId, statusIndicationKey: statusIndicationKey });
    }

    closeManageStatusIndicationModal = () => {
        this.setState({ showManageStatusIndicationModal: false, statusIndication: {}, statusIndicationId: null, statusIndicationKey: null });
    }

    deleteItem = () => {
        let me = this;
        let { component } = me.props;
        let { statusIndications } = component.state;
        let { targetDeleteId } = me.state;
        let { makeData } = me;

        if (targetDeleteId) {
            let target = statusIndications.filter(x => x.id == targetDeleteId)[0];

            target.isDeleteRequested = true;

            let others = statusIndications.filter(x => x.id != targetDeleteId);
            let newValues = [];

            if (target.id && !target.isVirtualId) {
                newValues = [...others, target];
            } else {
                newValues = [...others];
            }


            component.setState(
                { statusIndications: newValues }, () => {
                    makeData();
                    me.setState({ targetDeleteId: null, showConfirmModal: false });
                });
        }
    }

    makeData = () => {
        let { openModal, openManageStatusIndicationModal } = this;
        let { component } = this.props;
        let { statusIndications, periods } = component.state;

        var validOptions = statusIndications.filter(x => !(x.isDeleteRequested == true)).sort((a, b) => a.weight - b.weight);

        var data = validOptions.map((e, i) => {
            let statusIndicationPeriod = periods.filter(x => x.id == e.periodId)[0];
            var id = e.id;

            e.rowOrder = "";

            e.rowStatusIndicationName = (<div className="table-cell-height-limited">{statusIndicationPeriod?.name}</div>);
            e.rowNeededScore = (<div className="table-cell-height-limited">{e.neededScore}</div>);
            e.rowActions = (
                <DropdownMenu
                    items={[
                        { type: DROPDOWN_MENU_TYPE_ITEM, title: <EditItemTitle />, props: { onClick: () => openManageStatusIndicationModal(e, id, e.key) } },
                        { type: DROPDOWN_MENU_TYPE_ITEM, title: <RemoveItemTitle />, props: { onClick: () => openModal(id) } }
                    ]}
                />);

            return e;
        });
        this.setState({ draggableTableData: data });
    };

    setData = (event) => {
        const { active, over } = event;
        let { component } = this.props;
        const { statusIndications } = component.state;

        const { draggableTableData } = this.state;

        const items = draggableTableData?.map(({ id }) => id);

        if (active.id !== over.id) {

            const oldIndex = items.indexOf(active.id);
            const newIndex = items.indexOf(over.id);
            let reorderedData = arrayMove(draggableTableData, oldIndex, newIndex);

            let ordersDisctionary = [];

            reorderedData.map((e, i) => {
                e.weight = i;
                ordersDisctionary.push({ statusIndicationId: e.id, weight: i });
                return e;
            });

            statusIndications.map((q, i) => {
                let weight = ordersDisctionary.filter(x => x.statusIndicationId == q.id)[0]?.weight;
                q.weight = weight;
                return q;
            });

            component.setState({ statusIndications: statusIndications }, () => { this.setState({ draggableTableData: reorderedData }) });


        }
    };


    render() {
        const { loading, actionLoading, error, message, showConfirmModal, showManageStatusIndicationModal, draggableTableData, statusIndication, statusIndicationKey, statusIndicationId } = this.state;

        const { deleteItem, closeModal, openManageStatusIndicationModal, closeManageStatusIndicationModal, setData, makeData } = this;

        let { component, periods, statusIndications } = this.props;

        let { totalStatusIndicationItems } = this.props;

        const validPeriods = periods.filter(x => x.name && !isNullOrEmpty(x.name) && !(x.isDeleteRequested && x.isDeleteRequested == true));
        const validStatusIndications = statusIndications.filter(x => x.name && !isNullOrEmpty(x.name) && !(x.isDeleteRequested && x.isDeleteRequested == true));
        let nextStatusIndicationKey = totalStatusIndicationItems + 1;
        let mode = statusIndication.id ? "edit" : "add";

        const headers = [
            { Header: "#", accessor: "rowOrder", style: { width: "10%", textAlign: "center" } },
            { Header: "Indicar período", accessor: "rowStatusIndicationName", style: { width: "40%" } },
            { Header: "Se resultado < que ", accessor: "rowNeededScore", style: { width: "45%" } },
            { Header: "Ações", accessor: "rowActions", style: { width: "5%" } }
        ];

        return (
            <div>
                {loading === true && <PageLoadingIndicator loadingText={actionLoading ? "Por favor, aguarde..." : "Carregando informações..."} />}
                {loading === false && error === true && <PageAlert className="m-b-20" message={"Erro"} description={message} type="danger" />}
                {loading === false && error === false && draggableTableData.length <= 0 && <PageAlert className="m-b-20" message={"Sem informações"} description={"Não há dados para exibir no momento..."} type="info" dismissible />}
                {loading === false && (
                    <Container>
                        <Row>
                            <Col size={4} className="mt-4">
                                <AddButton
                                    containerProps={{
                                        onClick: () => openManageStatusIndicationModal(),
                                        disabled: validPeriods.length < 1
                                    }}

                                />
                            </Col>
                            <Container>
                                <h6 className="float-end mt-4 mb-4">Total de indicações: {draggableTableData.length || 0}</h6>
                                <TableStyles>
                                    <DraggableTable columns={headers} data={draggableTableData} setData={setData} />
                                </TableStyles>
                            </Container>
                        </Row>
                        <ManageStatusIndicationModal
                            show={showManageStatusIndicationModal}
                            afterSubmit={makeData}
                            onClose={closeManageStatusIndicationModal}
                            component={component}
                            periods={validPeriods}
                            statusIndications={validStatusIndications}
                            statusIndicationKey={statusIndicationKey != null ? statusIndicationKey : nextStatusIndicationKey}
                            statusIndicationId={statusIndicationId}
                            statusIndication={statusIndication}
                            mode={mode}
                        />
                        <PageModal
                            show={showConfirmModal}
                            onClose={closeModal}
                            onConfirm={deleteItem} />
                    </Container>
                )}
            </div>
        );
    };
}

export default StatusIndicationTabEvaluationSchemeForm;


